import { render, staticRenderFns } from "./ItchGames.vue?vue&type=template&id=0513a596&scoped=true&"
import script from "./ItchGames.vue?vue&type=script&lang=js&"
export * from "./ItchGames.vue?vue&type=script&lang=js&"
import style0 from "./ItchGames.vue?vue&type=style&index=0&id=0513a596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0513a596",
  null
  
)

export default component.exports